export default "__VITE_ASSET__sOUSSJy___"